import { NodeEventPlugin } from '@lexical/react/LexicalNodeEventPlugin';
import {
  $isAutoLinkNode,
  AutoLinkNode,
  LinkNode,
} from '@synoptic/lexical-nodes/link.ts';
import { $getNodeByKey } from 'lexical';
import { useNavigate } from 'react-router';

const isSameOrigin = (url: URL) => {
  const origin = url.origin.replace('www.', '');

  const currentOrigin = window.location.origin.replace('www.', '');

  return origin === currentOrigin;
};

export const ClickableLinkPlugin = () => {
  const navigate = useNavigate();

  return (
    <NodeEventPlugin
      nodeType={LinkNode}
      eventType={'click'}
      eventListener={(e, _editor, nodeKey) => {
        const node = $getNodeByKey(nodeKey) as AutoLinkNode | LinkNode;

        if ($isAutoLinkNode(node) && node.getIsUnlinked()) {
          return;
        }

        const event = e as MouseEvent;
        event.stopPropagation();
        event.preventDefault();

        const url = new URL(node.getURL());

        if (isSameOrigin(url)) {
          return navigate(url.pathname + url.search);
        }

        window.open(url, '_blank');
      }}
    />
  );
};
